import React from 'react';


function HeaderWhatWeDo() {
  return (
    <div className="wrapper py-6 header-what-do">
      <div className="container-fluid my-5">
        <div className="row">
          <div className="col">
            <h1 className="font-weight-bolder underscore title">We<br />revolutionise<br />industries</h1>
            <div className="text-white d-flex flex-column align-items-start">
              <div className="py-2 px-3 bg-primary display-2 mb-1">HEALTHCARE</div>
              <div className="py-2 px-3 bg-primary display-2 mb-1">MANUFACTURING</div>
              <div className="py-2 px-3 bg-primary display-2 mb-1">SHIPPING</div>
              <div className="py-2 px-3 bg-primary display-2 mb-1">FINANCE</div>
              <div className="py-2 px-3 bg-primary display-2 mb-1">ONLINE RETAIL</div>
              <div className="py-2 px-3 bg-primary display-2 mb-1">DRONES</div>
              <div className="py-2 px-3 bg-primary display-2 mb-1">SOUND & ACOUSTICS</div>
              <div className="py-2 px-3 bg-primary display-2 mb-1">AGRICULTURE</div>
              <div className="py-2 px-3 bg-primary display-2 mb-1">SUSTAINABILITY</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeaderWhatWeDo;
